/** eslint disable no-unexpected-multiline*/
import styled, { css } from "styled-components";
import breakpoints from "Helpers/BreakpointHelper";
import media from "styled-media-query";
import PropTypes from "prop-types";

const flexOptions = [
  "stretch",
  "center",
  "flex-start",
  "flex-end",
  "baseline",
  "initial",
  "space-evenly",
  "space-around",
  "space-between",
];
/**
 * FlexContainer
 */
export const FlexContainer = styled.div.attrs(
  ({
    marginright,
    marginleft,
    column,
    alignItems,
    alignself,
    justifyContent,
    flex,
    maxwidth,
    minwidth,
    maxwidthsmall,
    smallwidth,
    perspective,
    margin,
    smallmargin,
    width,
    padding,
    smallpadding,
    minheight,
    minheightMobile,
    zindex,
    smallrow,
    smallAlignContent,
    backgroundImage,
    overflow,
    flexwrap,
    flexgrow,
    gap,
  }) => ({
    marginright: marginright ? "2rem" : 0,
    marginleft: marginleft ? marginleft : 0,
    flexdirection: column ? "column" : "row",
    alignment: alignItems ? alignItems : "stretch",
    alignself: alignself ? alignself : "",
    justification: justifyContent ? justifyContent : "flex-start",
    flex: flex ? flex : "initial",
    maxwidth: maxwidth ? maxwidth : "initial",
    minwidth: minwidth ? minwidth : "initial",
    maxwidthsmall: maxwidthsmall && maxwidth ? maxwidth : "none",
    smallwidth: smallwidth ? smallwidth : "100%",
    perspective: perspective ? "900px" : "initial",
    margin: margin ? margin : 0,
    smallmargin: smallmargin,
    width: width ? width : "100%",
    padding: padding ? padding : 0,
    smallpadding: smallpadding,
    minheight: minheight ? minheight : "unset",
    minheightMobile: minheightMobile ? minheightMobile : minheight,
    zindex: zindex ? zindex : "initial",
    smalldirection: smallrow ? "row" : "column",
    smallAlignContent: smallAlignContent,
    backgroundImage: backgroundImage ? backgroundImage : "",
    overflow: overflow ? overflow : "",
    wrap: flexwrap ? flexwrap : "",
    grow: flexgrow ? flexgrow : 1,
    gap: gap ? gap : undefined,
  })
)`
  margin-right: ${({ marginright }) => marginright};
  margin-left: ${({ marginleft }) => marginleft};
  margin: ${({ margin }) => margin};
  padding: ${({ padding }) => padding};
  display: flex;
  border-left: ${({ borderLeft }) => borderLeft};
  border-right: ${({ borderRight }) => borderRight};
  flex-direction: ${({ flexdirection }) => flexdirection};
  align-items: ${({ alignment }) => alignment};
  align-self: ${({ alignself }) => alignself};
  justify-content: ${({ justification }) => justification};
  flex: ${({ flex }) => flex};
  max-width: ${({ maxwidth }) => maxwidth};
  min-height: ${({ minheight }) => minheight};
  min-width: 1px;
  min-width: ${({ minwidth }) => minwidth};
  background: ${({ backgroundImage }) => backgroundImage};
  width: ${({ width }) => width};
  position: relative;
  perspective: ${({ perspective }) => perspective};
  z-index: ${({ zindex }) => zindex};
  flex-wrap: ${({ wrap }) => wrap};
  flex-grow: ${({ grow }) => grow};
  ${({ gap }) =>
    gap &&
    css`
      gap: ${({ gap }) => gap};
    `}
  ${media.lessThan(breakpoints.ipad)`
		overflow: ${({ overflow }) => overflow};
		flex-direction: ${({ smalldirection }) => smalldirection};
		align-items: ${({ smallAlignContent }) =>
      smallAlignContent ? smallAlignContent : "stretch"};
		width: ${({ smallwidth }) => smallwidth};
		max-width: ${({ maxwidthsmall }) => maxwidthsmall};
		margin: ${({ smallmargin }) => smallmargin};
		padding: ${({ smallpadding }) => smallpadding};
		justify-content: ${({ justification }) => justification};
		border: 0;
  `};
  ${media.lessThan(breakpoints.mobile)`
    	min-height: ${({ minheightMobile }) => minheightMobile}
  `};
`;

/**
 * FlexContainerCentered
 */
export const FlexContainerCentered = styled(FlexContainer).attrs(
  ({ marginbottom }) => ({
    marginbottom: marginbottom ? marginbottom : "0",
  })
)`
  margin: 0 auto;
  margin-bottom: ${({ marginbottom }) => marginbottom};
`;

FlexContainer.propTypes = {
  margin: PropTypes.string,
  marginright: PropTypes.string,
  marginleft: PropTypes.string,
  column: PropTypes.bool,
  alignItems: PropTypes.oneOf(flexOptions),
  justifyContent: PropTypes.oneOf(flexOptions),
  smallAlignContent: PropTypes.oneOf(flexOptions),
};
